import { EspAccount, EspAccountWithCustomMTAConfig } from 'modules/graphql/types';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../types';

const {
  NAME,
  API_KEY,
  ESP,
  ID,
  EDIT_API_KEY,
  IS_DEFAULT,
  BINDING,
  API_ENDPOINT,
  SIGNING_SECRET,
  IS_SENDER_ITERABLE,
  EDIT_SIGNING_SECRET,
  AUTH_TYPE,
  CLIENT_SECRET,
  EDIT_CLIENT_SECRET,
  CLIENT_ID,
  TOKEN_ENDPOINT,
  CUSTOM_HEADERS,
} = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const createInitialValues = (espAccount: EspAccount | EspAccountWithCustomMTAConfig) => {
  const {
    id,
    esp,
    name,
    isDefault,
    binding,
    /**
     * Only 4 characters of the API key are returned from the BE. Those 4 characters
     * are shown so customers can cross-reference their existing keys.
     */
    truncatedApiKey,
    /**
     * apiEndpoint is currently being renamed to customApiEndpoint before being
     * returned to the FE.
     */
    customApiEndpoint,
    signingSecretPrefix,
    isSenderIterable,
  } = espAccount;
  const customMTAConfig = (espAccount as EspAccountWithCustomMTAConfig)?.customMTAConfig;
  return {
    [ESP]: esp,
    [NAME]: name,
    [API_KEY]: truncatedApiKey?.padEnd(20, '*'),
    [ID]: id,
    [IS_DEFAULT]: isDefault,
    [BINDING]: binding,
    ...(customApiEndpoint ? { [API_ENDPOINT]: customApiEndpoint } : {}),
    ...(signingSecretPrefix ? { [SIGNING_SECRET]: signingSecretPrefix?.padEnd(20, '*') } : {}),
    ...(isSenderIterable ? { [IS_SENDER_ITERABLE]: isSenderIterable } : {}),
    [EDIT_API_KEY]: false,
    [EDIT_SIGNING_SECRET]: false,
    ...(customMTAConfig
      ? {
          [API_ENDPOINT]: customMTAConfig?.apiEndpoint,
          [AUTH_TYPE]: customMTAConfig?.authType,
          [CLIENT_ID]: customMTAConfig?.authParams.clientId,
          [CLIENT_SECRET]: customMTAConfig?.authParams.clientSecret,
          [TOKEN_ENDPOINT]: customMTAConfig?.authParams.tokenEndpoint,
          [CUSTOM_HEADERS]: Object.entries(customMTAConfig?.customHeaders).map(([key, value]) => ({
            key,
            value,
          })),
          [EDIT_CLIENT_SECRET]: false,
        }
      : {}),
  };
};
